import React, { useEffect } from 'react';
import { Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { selectIssueCrashFilterModelOptionsInfo } from 'utils/selectors/selectors';
import { actionFetchModelOptions } from 'reducers/seniorSearch';

/**
 * iOS 机型多选组件。
 * 从 Redux store（seniorSearch.modelOptions）加载机型选项列表，渲染为多选 Select。
 * 仅封装数据加载 + 选择 UI，不含"包含/不包含"切换——IosDeviceSelect 在此基础上加了 SearchMethod wrapper。
 *
 * 注意：此处使用原生 antd Select 而非 CsSelect。CsSelect 内部会渲染 position:absolute + z-index:11 的
 * hover 态 Select，会创建新的层叠上下文，导致下拉列表向上展开时被上方的表单元素遮挡。
 */
const IosModelSelect = ({
  appId,
  isReadOnly,
  value,
  onChange = () => {},
  ...rest
}) => {
  const { hasFetched, options } = useSelector(selectIssueCrashFilterModelOptionsInfo);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!appId) {
      return;
    }
    if (!hasFetched) {
      dispatch(actionFetchModelOptions());
    }
  }, [appId]);

  return (
    <Select
      style={{ width: '100%' }}
      mode='multiple'
      options={options}
      optionFilterProp='label'
      value={value || []}
      onChange={(v) => {
        if (isReadOnly) {
          return;
        }
        onChange(v);
      }}
      {...rest}
    />
  );
};

export default IosModelSelect;
